import CustomerAvatar from './CustomerAvatar'
import './ContextBar.css'

/**
 * ContextBar - Shows customer context from real API data.
 *
 * Props:
 *   customer: object from GET /api/context/{id}
 *   dataSources: { tables, uploads, connections }
 */
export default function ContextBar({ customer, dataSources }) {
  const companyName = customer?.company_name || 'Loading…'
  const industry = customer?.industry || ''
  const employeeCount = customer?.employee_count
    ? customer.employee_count.toLocaleString()
    : '—'
  const hcmProduct = customer?.hcm_product || customer?.hcm_vendor || ''

  // Compute stats from real data
  const tables = dataSources?.tables?.length || 0
  const totalRows = dataSources?.tables?.reduce((sum, t) => sum + (t.row_count || 0), 0) || 0
  const rowsDisplay = totalRows > 1000 ? `${(totalRows / 1000).toFixed(1)}K` : totalRows.toString()
  const connectionsCount = dataSources?.connections?.length || 0


  return (
    <div className="context-bar">
      <div className="context-left">
        <CustomerAvatar customerId={customer?.customer_id} companyName={companyName} website={customer?.website} logoBase64={customer?.logo_base64} size="md" />
        <div className="context-info">
          <div className="context-company">{companyName}</div>
          <div className="context-detail">
            {[industry, `${employeeCount} employees`, hcmProduct].filter(Boolean).join(' · ')}
          </div>
        </div>
      </div>
      <div className="context-right">
        <div className="context-stat">
          <div className="context-stat-value">{tables}</div>
          <div className="context-stat-label">Tables</div>
        </div>
        <div className="context-stat">
          <div className="context-stat-value">{rowsDisplay}</div>
          <div className="context-stat-label">Rows</div>
        </div>
        <div className="context-divider" />
        <span className="context-badge connected">{connectionsCount} Connection{connectionsCount !== 1 ? 's' : ''}</span>
      </div>
    </div>
  )
}

